import * as actions from '../actions'

var defaultState = null

export default function resourceAll(state = defaultState, action) {
    switch (action.type) {
        case actions.RESOURCE_GET_ALL:
            var newState = state
            if (!action.error && action.payload.data && action.payload.data) {
                newState = action.payload.data
            }
            return newState
        case actions.RESOURCE_GET_ALL_CLEAN:
            return defaultState
        default:
            return state
    }
}
